export const removeTanachAnotations = (str: string) =>
  str.replace(/\(ס\)/g, '').replace(/\(פ\)/g, '').replace(/\s׀/g, '')

export const removeKsivForKria = (str: string) =>
  str.replace(/\S*\s(?=\[\S*\])/g, '')

export const formatTanachStringForSiddur = (str: string) =>
  removeTanachAnotations(removeKsivForKria(str))
